<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator="/">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>招商管理</el-breadcrumb-item>
      <el-breadcrumb-item>客户沟通</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- 卡片视图区 -->
    <el-card class="box-card">
      <div slot="header" class="flexContainer">
        <span class="cardHeader">客户沟通</span>
        <span style="float:right;" v-if="isAdmin">
          <el-button size="small" icon="el-icon-calendar" @click="showCoverage">采集情况</el-button>
          <el-button size="small" icon="el-icon-refresh" @click="openRecollect()">补采</el-button>
          <el-button size="small" icon="el-icon-microphone" @click="showAsrJobs">转写队列</el-button>
        </span>
      </div>

      <!-- 查询条件 -->
      <el-form :inline="true" label-width="90px" size="small" style="margin-bottom: 10px;">
        <el-form-item label="关键词：">
          <el-input v-model="form.keyword" placeholder="昵称/备注模糊" clearable style="width: 180px;" @keyup.enter.native="search"></el-input>
        </el-form-item>
        <el-form-item label="专员：">
          <el-select v-model="form.wechatAccountId" placeholder="全部专员" clearable filterable style="width: 150px;">
            <el-option v-for="item in accountList" :key="item.wechatAccountId" :label="item.name" :value="item.wechatAccountId"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="添加日期：">
          <el-date-picker
            v-model="form.passTimeRange"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            style="width: 240px;">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="沟通日期：">
          <el-date-picker
            v-model="form.msgDateRange"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            style="width: 240px;">
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="search" :loading="loading">查询</el-button>
          <el-button @click="resetFilters">重置</el-button>
        </el-form-item>
      </el-form>

      <!-- 表格区域 -->
      <el-table :data="list" border style="width: 100%" v-loading="loading">
        <el-table-column type="index" label="序号" width="60" :index="indexBase"></el-table-column>
        <el-table-column label="昵称" min-width="160" show-overflow-tooltip>
          <template slot-scope="scope">{{ scope.row.nickname || '（空）' }}</template>
        </el-table-column>
        <el-table-column label="备注" min-width="200" show-overflow-tooltip>
          <template slot-scope="scope">{{ scope.row.conRemark || '（空）' }}</template>
        </el-table-column>
        <el-table-column prop="ownerName" label="专员" width="90"></el-table-column>
        <el-table-column label="添加日期" width="150">
          <template slot-scope="scope">
            <span v-if="scope.row.passTime">{{ scope.row.passTime | dateFormat }}</span>
            <span v-else>未知</span>
          </template>
        </el-table-column>
        <el-table-column label="最近沟通" width="150">
          <template slot-scope="scope">
            <span v-if="scope.row.lastMsgTime">{{ scope.row.lastMsgTime | dateFormat }}</span>
            <span v-else style="color:#909399;">无记录</span>
          </template>
        </el-table-column>
        <el-table-column prop="msgCount" label="消息数" width="90"></el-table-column>
        <el-table-column label="操作" width="110" fixed="right">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="openDetail(scope.row)">查看聊天</el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <el-pagination
        style="margin-top: 15px; text-align: right;"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pagenum"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pagesize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </el-card>

    <!-- 补采对话框（管理员）：整日全账号 / 按账号区间 两种模式 -->
    <el-dialog title="手动补采" :visible.sync="recollectVisible" width="480px" :close-on-click-modal="false">
      <el-radio-group v-model="recollectMode" size="small" style="margin-bottom: 12px;">
        <el-radio-button label="day">整日补采（全部账号）</el-radio-button>
        <el-radio-button label="range">按账号区间补采</el-radio-button>
      </el-radio-group>
      <el-form label-width="90px" size="small" v-if="recollectMode === 'day'">
        <el-form-item label="采集日期：">
          <el-date-picker v-model="recollectDate" type="date" format="yyyy-MM-dd" value-format="yyyy-MM-dd" placeholder="选择日期" style="width: 200px;"></el-date-picker>
        </el-form-item>
        <div style="color:#909399;font-size:12px;line-height:1.8;">
          按指定日期重跑全量账号采集（幂等，已采消息自动去重），一轮约需 40 分钟。
        </div>
      </el-form>
      <el-form label-width="90px" size="small" v-else>
        <el-form-item label="专员账号：">
          <el-select v-model="recollectAccount" placeholder="选择账号" filterable style="width: 240px;">
            <el-option v-for="item in accountList" :key="item.wechatAccountId" :label="item.name" :value="item.wechatAccountId"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="日期区间：">
          <el-date-picker
            v-model="recollectRange"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期（≤昨天）"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            style="width: 280px;">
          </el-date-picker>
        </el-form-item>
        <div style="color:#909399;font-size:12px;line-height:1.8;">
          分片后台慢跑（逐日持锁后释放，避开 00:50~03:10 调度窗口让路每日任务）；进度在"采集情况"中查看，可取消/续跑。
        </div>
      </el-form>
      <span slot="footer">
        <el-button @click="recollectVisible = false" size="small">取消</el-button>
        <el-button type="primary" size="small" @click="submitRecollect" :loading="recollectLoading">开始补采</el-button>
      </span>
    </el-dialog>

    <!-- 采集情况对话框（管理员）：逐日覆盖 + 补采任务进度 -->
    <el-dialog title="采集覆盖情况" :visible.sync="coverageVisible" width="860px" top="5vh">
      <div style="margin-bottom:10px;">
        <el-date-picker
          v-model="coverageRange"
          type="daterange"
          size="small"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd"
          style="width: 260px; margin-right: 8px;"
          @change="loadCoverage">
        </el-date-picker>
        <el-button size="small" type="primary" @click="loadCoverage" :loading="coverageLoading">查询</el-button>
        <span style="font-size:12px;color:#909399;margin-left:10px;">
          在职绑定账号 {{ coverageTotal }} 个；{{ coverageBaseline }} 及之前为迁移基线（历史已导入，无需补采）
        </span>
      </div>
      <el-table :data="coverageDays" size="mini" border max-height="330" v-loading="coverageLoading">
        <el-table-column prop="date" label="日期" width="100"></el-table-column>
        <el-table-column label="状态" width="90">
          <template slot-scope="scope">
            <el-tag size="mini" :type="covTagType(scope.row)">{{ covText(scope.row) }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="账号覆盖" width="90">
          <template slot-scope="scope">{{ scope.row.coveredAccounts }}/{{ scope.row.totalAccounts }}</template>
        </el-table-column>
        <el-table-column label="未采账号" min-width="140">
          <template slot-scope="scope">
            <span v-if="!scope.row.absentAccounts.length" style="color:#C0C4CC;">—</span>
            <el-tooltip v-else :content="scope.row.absentAccounts.join('、')" placement="top">
              <span style="color:#E6A23C;">{{ scope.row.absentAccounts.slice(0, 3).join('、') }}{{ scope.row.absentAccounts.length > 3 ? ' 等' : '' }}</span>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column label="失败账号" min-width="120">
          <template slot-scope="scope">
            <span v-if="!scope.row.failedAccounts.length" style="color:#C0C4CC;">—</span>
            <el-tooltip v-else :content="scope.row.failedAccounts.join('；')" placement="top">
              <span style="color:#F56C6C;">{{ scope.row.failedAccounts.length }} 个失败，悬停查看</span>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column prop="msgs" label="消息数" width="80"></el-table-column>
        <el-table-column prop="source" label="来源" width="70">
          <template slot-scope="scope">{{ scope.row.source === 'manual' ? '补采' : scope.row.source || '—' }}</template>
        </el-table-column>
        <el-table-column label="操作" width="90" fixed="right">
          <template slot-scope="scope">
            <el-button v-if="scope.row.date > coverageBaseline" type="text" size="mini" @click="openRecollect(scope.row.date)">补采此日</el-button>
          </template>
        </el-table-column>
      </el-table>

      <div style="margin-top:14px;font-weight:bold;">补采任务</div>
      <el-table :data="backfillTasks" size="mini" border max-height="180" style="margin-top:6px;" v-loading="backfillLoading">
        <el-table-column prop="ownerName" label="账号" width="80"></el-table-column>
        <el-table-column label="区间" width="180">
          <template slot-scope="scope">{{ scope.row.dateFrom }} ~ {{ scope.row.dateTo }}</template>
        </el-table-column>
        <el-table-column label="进度" width="160">
          <template slot-scope="scope">
            <el-progress :percentage="scope.row.daysTotal ? Math.round(scope.row.daysDone / scope.row.daysTotal * 100) : 0" :stroke-width="12" :text-inside="true"></el-progress>
          </template>
        </el-table-column>
        <el-table-column label="天数" width="80">
          <template slot-scope="scope">{{ scope.row.daysDone }}/{{ scope.row.daysTotal }}</template>
        </el-table-column>
        <el-table-column prop="msgs" label="消息" width="70"></el-table-column>
        <el-table-column label="状态" width="80">
          <template slot-scope="scope">
            <el-tag size="mini" :type="scope.row.status === 'running' ? 'warning' : (scope.row.status === 'done' ? 'success' : 'info')">{{ bfStatusText(scope.row) }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="80">
          <template slot-scope="scope">
            <el-button v-if="scope.row.status === 'running' && !scope.row.cancelRequested" type="text" size="mini" @click="cancelBackfill(scope.row)">取消</el-button>
            <el-button v-else-if="scope.row.status !== 'done' && scope.row.cursor" type="text" size="mini" @click="resumeBackfill(scope.row)">续跑</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>

    <!-- 转写队列对话框 -->
    <el-dialog title="ASR 转写队列" :visible.sync="asrVisible" width="560px">
      <div v-if="asrCounts">
        <el-row :gutter="10" style="margin-bottom:15px;">
          <el-col :span="4" v-for="(v, k) in asrCounts" :key="k"><div class="asr-stat"><div class="num">{{ v }}</div><div class="lbl">{{ asrLabel(k) }}</div></div></el-col>
        </el-row>
        <div v-if="asrFailed.length" style="max-height:220px;overflow-y:auto;">
          <div style="font-weight:bold;margin-bottom:6px;">最近失败</div>
          <div v-for="f in asrFailed" :key="f.id" style="font-size:12px;color:#F56C6C;border-bottom:1px dashed #EBEEF5;padding:4px 0;">
            {{ f.id }}（第{{ f.attemptsMade }}次）：{{ f.failedReason }}
          </div>
        </div>
      </div>
      <div v-else style="text-align:center;color:#909399;">加载中…</div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'ZhaoshangChatList',
  data () {
    return {
      loading: false,
      list: [],
      total: 0,
      pagenum: 1,
      pagesize: 20,
      accountList: [],
      form: {
        keyword: '',
        wechatAccountId: '',
        passTimeRange: null,
        msgDateRange: null
      },
      recollectVisible: false,
      recollectMode: 'day',
      recollectDate: '',
      recollectAccount: '',
      recollectRange: null,
      recollectLoading: false,
      coverageVisible: false,
      coverageLoading: false,
      coverageRange: null,
      coverageDays: [],
      coverageTotal: 0,
      coverageBaseline: '',
      backfillTasks: [],
      backfillLoading: false,
      asrVisible: false,
      asrCounts: null,
      asrFailed: [],
      isAdmin: false
    }
  },
  computed: {
    indexBase () {
      return (this.pagenum - 1) * this.pagesize + 1
    }
  },
  created () {
    // 后端另有 403 硬拒，此处仅隐藏入口；level 来自登录注入的 sessionStorage，
    // 须在挂载时求值（computed 无响应式依赖会被永久缓存，登录态变更后不刷新）
    const lv = Number(sessionStorage.getItem('level'))
    this.isAdmin = lv === 0 || lv === 1
    this.getAccounts()
    this.getList()
  },
  methods: {
    async getAccounts () {
      try {
        const { data: res } = await this.$http.get('zhaoshang/chat/accounts')
        if (res.meta.status === 200) {
          this.accountList = res.data.list || []
        }
      } catch (e) {
        // 下拉加载失败不阻断列表
      }
    },
    async getList () {
      this.loading = true
      try {
        const params = {
          keyword: this.form.keyword,
          wechatAccountId: this.form.wechatAccountId,
          passTimeFrom: (this.form.passTimeRange && this.form.passTimeRange[0]) || '',
          passTimeTo: (this.form.passTimeRange && this.form.passTimeRange[1]) || '',
          msgDateFrom: (this.form.msgDateRange && this.form.msgDateRange[0]) || '',
          msgDateTo: (this.form.msgDateRange && this.form.msgDateRange[1]) || '',
          pagenum: this.pagenum,
          pagesize: this.pagesize
        }
        const { data: res } = await this.$http.get('zhaoshang/chat/friends', { params })
        if (res.meta.status === 200) {
          this.list = res.data.list || []
          this.total = res.data.total || 0
        } else {
          this.$message.error(res.meta.msg || '查询失败')
        }
      } catch (e) {
        this.$message.error('查询失败')
      } finally {
        this.loading = false
      }
    },
    search () {
      this.pagenum = 1
      this.getList()
    },
    resetFilters () {
      this.form = { keyword: '', wechatAccountId: '', passTimeRange: null, msgDateRange: null }
      this.search()
    },
    handleSizeChange (v) {
      this.pagesize = v
      this.pagenum = 1
      this.getList()
    },
    handleCurrentChange (v) {
      this.pagenum = v
      this.getList()
    },
    openDetail (row) {
      this.$router.push({ path: '/zhaoshang/chat-detail', query: { wechatAccountId: row.wechatAccountId, friendId: row.id } })
    },
    openRecollect (date) {
      this.recollectMode = 'day'
      this.recollectDate = date || ''
      this.recollectAccount = ''
      this.recollectRange = null
      this.recollectVisible = true
    },
    async submitRecollect () {
      if (this.recollectMode === 'day') {
        if (!this.recollectDate) {
          this.$message.warning('请选择采集日期')
          return
        }
        this.doRecollect({ date: this.recollectDate })
      } else {
        if (!this.recollectAccount) {
          this.$message.warning('请选择专员账号')
          return
        }
        if (!this.recollectRange || !this.recollectRange[0] || !this.recollectRange[1]) {
          this.$message.warning('请选择日期区间')
          return
        }
        this.doRecollect({ wechatAccountId: this.recollectAccount, dateFrom: this.recollectRange[0], dateTo: this.recollectRange[1] })
      }
    },
    async doRecollect (body) {
      this.recollectLoading = true
      try {
        const { data: res } = await this.$http.post('zhaoshang/chat/recollect', body)
        if (res.meta.status === 200) {
          this.$message.success(res.meta.msg || '补采已受理')
          this.recollectVisible = false
        } else {
          this.$message.error(res.meta.msg || '受理失败')
        }
      } catch (e) {
        this.$message.error('受理失败')
      } finally {
        this.recollectLoading = false
      }
    },
    async showCoverage () {
      this.coverageVisible = true
      if (!this.coverageRange) {
        const today = new Date()
        const from = new Date(today.getTime() - 29 * 24 * 3600 * 1000)
        const fmt = d => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`
        this.coverageRange = [fmt(from), fmt(today)]
      }
      await Promise.all([this.loadCoverage(), this.loadBackfills()])
    },
    async loadCoverage () {
      if (!this.coverageRange) return
      this.coverageLoading = true
      try {
        const params = { dateFrom: this.coverageRange[0], dateTo: this.coverageRange[1] }
        const { data: res } = await this.$http.get('zhaoshang/chat/collectRuns', { params })
        if (res.meta.status === 200) {
          this.coverageDays = res.data.days || []
          this.coverageTotal = res.data.totalAccounts || 0
          this.coverageBaseline = res.data.baselineDate || ''
        } else {
          this.$message.error(res.meta.msg || '查询失败')
        }
      } catch (e) {
        this.$message.error('查询失败')
      } finally {
        this.coverageLoading = false
      }
    },
    async loadBackfills () {
      this.backfillLoading = true
      try {
        const { data: res } = await this.$http.get('zhaoshang/chat/backfills')
        if (res.meta.status === 200) {
          this.backfillTasks = res.data.list || []
        }
      } catch (e) {
        // 静默
      } finally {
        this.backfillLoading = false
      }
    },
    covTagType (row) {
      if (row.status === 'missing') {
        return row.date <= this.coverageBaseline ? 'info' : 'danger'
      }
      return { done: 'success', partial: 'warning', error: 'danger', running: 'warning' }[row.status] || 'info'
    },
    covText (row) {
      if (row.status === 'missing') {
        return row.date <= this.coverageBaseline ? '迁移基线' : '未采集'
      }
      return { done: '完成', partial: '部分', error: '失败', running: '进行中' }[row.status] || row.status
    },
    bfStatusText (row) {
      if (row.status === 'running' && row.cancelRequested) return '取消中'
      return { running: '进行中', done: '完成', canceled: '已取消', error: '异常' }[row.status] || row.status
    },
    async cancelBackfill (row) {
      try {
        const { data: res } = await this.$http.post('zhaoshang/chat/backfillCancel', { id: row.id })
        if (res.meta.status === 200) {
          this.$message.success(res.meta.msg || '取消请求已受理')
          setTimeout(() => this.loadBackfills(), 1500)
        } else {
          this.$message.error(res.meta.msg || '操作失败')
        }
      } catch (e) {
        this.$message.error('操作失败')
      }
    },
    async resumeBackfill (row) {
      this.recollectMode = 'range'
      this.recollectAccount = row.wechatAccountId
      this.recollectRange = [row.dateFrom, row.dateTo]
      this.recollectVisible = true
      this.$message.info('已带入原区间，确认后提交即从上次游标续跑')
    },
    async showAsrJobs () {
      this.asrVisible = true
      this.asrCounts = null
      this.asrFailed = []
      try {
        const { data: res } = await this.$http.get('zhaoshang/chat/asrJobs')
        if (res.meta.status === 200) {
          this.asrCounts = res.data.counts || {}
          this.asrFailed = res.data.recentFailed || []
        }
      } catch (e) {
        this.$message.error('队列状态获取失败')
      }
    },
    asrLabel (k) {
      const map = { wait: '待转写', active: '转写中', delayed: '重试等待', prioritized: '排队中', completed: '已完成', failed: '失败' }
      return map[k] || k
    }
  }
}
</script>

<style scoped>
.asr-stat { text-align: center; border: 1px solid #EBEEF5; border-radius: 4px; padding: 8px 0; }
.asr-stat .num { font-size: 20px; font-weight: bold; color: #409EFF; }
.asr-stat .lbl { font-size: 12px; color: #909399; }
</style>
